// extracted by mini-css-extract-plugin
export var item = "MetaNav-module--item--81c1e";
export var languages = "MetaNav-module--languages--1646d";
export var metaNavWrapper = "MetaNav-module--metaNavWrapper--1f565";
export var navItem = "MetaNav-module--nav-item--cdf92";
export var selectedLanguage = "MetaNav-module--selectedLanguage--73003";